module.exports = __webpack_public_path__ + "img/campus-4.d2a5ec0c.png";